export default __webpack_public_path__ + "static/media/medvice-logo.0101cc4e.svg";